import React from "react";
import { Phone } from "lucide-react";
import { SITE } from "../lib/site";

export default function FloatingCallButton() {
  return (
    <a
      href={`tel:${SITE.phoneTel}`}
      data-testid="floating-call-btn"
      className="lg:hidden fixed bottom-6 right-6 z-50 inline-flex items-center justify-center gap-2 bg-[#EAB308] text-[#0A0A0A] font-bold px-5 py-4 shadow-2xl shadow-yellow-500/30 hover:bg-[#CA8A04] transition-colors rounded-sm"
    >
      <Phone className="w-5 h-5" strokeWidth={2.5} />
      <span className="hidden sm:inline">Appeler</span>
    </a>
  );
}
